import { render } from "./secured-by-flutterwave.vue?vue&type=template&id=fd9d9608&scoped=true"
import script from "./secured-by-flutterwave.vue?vue&type=script&lang=js"
export * from "./secured-by-flutterwave.vue?vue&type=script&lang=js"

import "./secured-by-flutterwave.vue?vue&type=style&index=0&id=fd9d9608&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd9d9608"]])

export default __exports__